export const NAVIGATION_LIST = {
  appProps: {
    region: '',
    appId: 1180,
    downloadLink: {
      amazon: {
        visible: true,
        normal: 'https://www.amazon.com/dp/B07KR1RJL2/',
      },
      google: {
        visible: true,
        normal: 'https://app.appsflyer.com/com.ss.android.ugc.trill',
      },
      apple: {
        visible: true,
        normal: 'https://app.appsflyer.com/id1235601864',
      },
    },
    $isAndroid: false,
    $isIOS: true,
  },
  nav: [
    {
      title: 'Company',
      children: [
        {
          title: 'About',
          href: 'https://www.tiktok.com/about',
        },
        {
          title: 'Newsroom',
          href: 'https://newsroom.tiktok.com/',
        },
        {
          title: 'Contact',
          href: 'https://www.tiktok.com/contact',
        },
      ],
    },
    {
      title: 'Programs',
      children: [
        {
          title: 'TikTok for Good',
          href: 'https://www.tiktok.com/forgood',
          newWindow: true,
        },
        {
          title: 'Advertise on TikTok',
          href: 'https://ads.tiktok.com/?refer=tiktok_web',
          newWindow: true,
        },
      ],
    },
    {
      title: 'Support',
      children: [
        {
          title: 'Help Center',
          href: 'https://support.tiktok.com',
        },
        {
          title: 'Safety Center',
          href: 'https://www.tiktok.com/safety',
        },
        {
          title: 'Community Guidelines',
          href: 'https://support.tiktok.com/en/privacy-safety/community-policy-en',
        },
      ],
    },
    {
      title: 'Legal',
      children: [
        {
          title: 'Terms of Service',
          href: 'https://www.tiktok.com/legal/terms-of-use',
        },
        {
          title: 'Privacy Policy',
          href: 'https://www.tiktok.com/legal/privacy-policy',
        },
      ],
    },
  ],
  head: [
    {
      title: 'Home',
      href: 'https://www.tiktok.com/',
    },
    {
      title: 'About',
      href: 'https://www.tiktok.com/about',
    },
    {
      title: 'Trending',
      href: 'https://www.tiktok.com/trending',
      visibleOnMobile: true,
    },
    {
      title: 'Discover',
      href: 'https://www.tiktok.com/discover',
    },
    {
      title: 'Following',
      href: 'https://www.tiktok.com/following',
    },
  ],
  i18n: {
    logout: 'Log out',
    login: 'login',
    uploadVideo: 'Upload video',
    watchNow: 'Watch now',
    downloadOnAppStore: 'Download it for free on the App Store',
    downloadOnGooglePlay: 'Download it for free on Google Play',
    reflowDownload: 'Download now',
    download: 'Download',
    trending: 'Trending',
    discover: 'Discover',
    cookieBannerTitle: 'Accept cookies from TikTok on this browser?',
    cookieBannerSubTitle:
      'We use cookies and other technologies to improve your experience on our websites. By clicking "Accept all", you agree to let us use third-party cookies for analytics and advertising purposes. You can learn more about how we use cookies in our <a href="https://www.tiktok.com/legal/tiktok-website-cookies-policy?lang=en" target="_blank" rel="noopener noreferrer">Cookies Policy</a>. To manage your cookies, click "Manage settings".',
    cookieBannerBtnManage: 'Manage settings',
    cookieBannerBtnAccept: 'Accept all',
    cookiesBannerDetails:
      'We and our partners use cookies and other technologies to  analyze traffic and optimize your experience. View more info and control your  cookies settings at any time in our Cookies Policy.',
    cookiesBannerCookiesPolicyLink: 'Cookies Policy',
    cookiesBannerCookiesPolicy: 'Cookies Policy',
    cookiesBannerAccept: 'Accept',
    webDoNotSellSettingsSavedToast: 'Saved!',
    businessSuite: 'Business Suite',
    feedback: 'Feedback',
  },
  langList: [
    {
      value: 'id',
      label: 'Bahasa Indonesia',
    },
    {
      value: 'de',
      label: 'Deutsch',
    },
    {
      value: 'en',
      label: 'English',
    },
    {
      value: 'es',
      label: 'Español',
    },
    {
      value: 'fr',
      label: 'Français',
    },
    {
      value: 'it',
      label: 'Italiano',
    },
    {
      value: 'pl',
      label: 'Polski',
    },
    {
      value: 'pt_BR',
      label: 'Português',
    },
    {
      value: 'vi',
      label: 'Tiếng Việt',
    },
    {
      value: 'tr',
      label: 'Türkçe',
    },
    {
      value: 'ru',
      label: 'Русский',
    },
    {
      value: 'hi',
      label: 'हिन्दी',
    },
    {
      value: 'ko',
      label: '한국어',
    },
    {
      value: 'ja',
      label: '日本語',
    },
    {
      value: 'zh_Hant',
      label: '繁體中文',
    },
    {
      value: 'ar',
      label: 'العربية',
    },
  ],
};

export const EEA_COUNTRY_LIST = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'EL',
  'FI',
  'FR',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'NO',
  'IS',
  'LI',
];

export const EFFECTIVE_COUNTRY_LIST = [...EEA_COUNTRY_LIST, 'CH', 'GB', 'TR'];

export const FALLBACK_COOKIE_AWAIT_CONSENT = {
  version: 'v0',
  data: [],
};

export const RTL_LANGUAGE = ['ar'];

export const COOKIE_NAME = 'cookie-consent';

export const CUSTOM_FONT_URLS = [
  [
    'tiktok-display-bold',
    'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/TikTokDisplayFont-Bold.woff2?_default_font=1&v=2',
  ],
  [
    'tiktok-display-regular',
    'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/TikTokDisplayFont-Regular.woff2?_default_font=1&v=2',
  ],
  [
    'tiktok-display-medium',
    'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/TikTokDisplayFont-Semibold.woff2?_default_font=1&v=2',
  ],
  [
    'tiktok-text-bold',
    'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/TikTokFont-Bold.woff2?_default_font=1&v=2',
  ],
  [
    'tiktok-text-regular',
    'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/TikTokFont-Regular.woff2?_default_font=1&v=2',
  ],
  [
    'tiktok-text-medium',
    'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/TikTokFont-Semibold.woff2?_default_font=1&v=2',
  ],
];

export const closeIconSvg =
  '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M21.1718 23.9999L10.2931 13.1212C9.90261 12.7307 9.90261 12.0975 10.2931 11.707L11.7074 10.2928C12.0979 9.90228 12.731 9.90228 13.1216 10.2928L24.0002 21.1715L34.8789 10.2928C35.2694 9.90228 35.9026 9.90228 36.2931 10.2928L37.7073 11.707C38.0979 12.0975 38.0979 12.7307 37.7073 13.1212L26.8287 23.9999L37.7073 34.8786C38.0979 35.2691 38.0979 35.9023 37.7073 36.2928L36.2931 37.707C35.9026 38.0975 35.2694 38.0975 34.8789 37.707L24.0002 26.8283L13.1216 37.707C12.731 38.0975 12.0979 38.0975 11.7074 37.707L10.2931 36.2928C9.90261 35.9023 9.90261 35.2691 10.2931 34.8786L21.1718 23.9999Z"></path></svg>';
export const infoIconSvg =
  '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M814.983529 404.781176a45.176471 45.176471 0 0 1 0 63.849412l-256 256a45.176471 45.176471 0 0 1-63.849411 0L239.134118 468.630588a45.176471 45.176471 0 0 1 63.849411-63.849412l224.075295 224.075295 224.075294-224.075295a45.176471 45.176471 0 0 1 63.849411 0z"></path></svg>';

export const verticalbarIconSvg = `<svg width="1" height="24" viewBox="0 0 1 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0" y1="24" x2="0" stroke="#161823" stroke-opacity="0.12" stroke-width="1"/>
</svg>`;
